import WaterfallDisplay from 'pages/Waterfall/WaterfallDisplay/WaterfallDisplay';

const FirmWaterfall = () => (
  <WaterfallDisplay isFirmPage />
)

export default FirmWaterfall;